import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FHIRMedicationAdministration,
  FHIRMedicationRequest,
  FHIRMedicationStatement,
} from '../../../../models';

@Component({
  selector: 'app-medications-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './medications-section.component.html',
})
export class MedicationsSectionComponent {
  readonly administrations = input.required<FHIRMedicationAdministration[]>();
  readonly requests = input.required<FHIRMedicationRequest[]>();
  readonly statements = input.required<FHIRMedicationStatement[]>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'completed') return { color: 'bg-success', label: 'Completado' };
    if (s === 'active' || s === 'in-progress') return { color: 'bg-primary', label: 'Activo' };
    if (s === 'stopped' || s === 'cancelled') return { color: 'bg-danger', label: 'Cancelado' };
    if (s === 'on-hold') return { color: 'bg-warning text-dark', label: 'En Espera' };
    if (s === 'entered-in-error') return { color: 'bg-danger', label: 'Error de Entrada' };
    if (s === 'draft') return { color: 'bg-secondary', label: 'Borrador' };
    if (s === 'unknown') return { color: 'bg-secondary', label: 'Desconocido' };
    return { color: 'bg-secondary', label: status || '—' };
  }

  getMedName(resource: any): string {
    return (
      resource?.medicationCodeableConcept?.text ||
      resource?.medicationCodeableConcept?.coding?.[0]?.display ||
      '—'
    );
  }

  getMedCode(resource: any): string {
    return resource?.medicationCodeableConcept?.coding?.[0]?.code || '';
  }

  getDoseText(dosage: any): string {
    if (!dosage) return '—';
    if (dosage.text) return dosage.text;
    const dose = dosage.doseAndRate?.[0]?.doseQuantity;
    if (dose) return `${dose.value ?? ''} ${dose.unit ?? ''}`.trim();
    const d = dosage.dose;
    if (d) return `${d.value ?? ''} ${d.unit ?? ''}`.trim();
    return '—';
  }

  getRoute(dosage: any): string {
    return dosage?.route?.coding?.[0]?.display || dosage?.route?.text || '—';
  }

  getFrequency(dosage: any): string {
    const repeat = dosage?.timing?.repeat;
    if (!repeat) return '—';
    return `${repeat.frequency ?? ''} vez/veces cada ${repeat.period ?? ''} ${repeat.periodUnit ?? ''}`.trim();
  }
}
